export const UPLOAD_DOCUMENTS = 'UPLOAD_DOCUMENTS';
export const FETCH_DOCUMENTS = 'FETCH_DOCUMENTS';
export const DELETE_DOCUMENTS = 'DELETE_DOCUMENTS';



// WEBPACK FOOTER //
// ./src/store/modules/document/mutation-types.js